import React, { useState } from "react";
import { Box, Heading, Snackbar, Stack } from "@origin-digital/ods-core";
import RequestReportSection from "./RequestReportSection";
import CustomerCompanyReportSection from "./CustomerCompanyReportSection";

const Reports: React.FC = () => {
  const [unableToDownload, setUnableToDownload] = useState(false);

  return (
    <Box
      position={{
        lg: "relative",
        xs: "relative",
      }}
      paddingX={{
        xl: "xlarge",
        lg: "large",
      }}
      style={{ maxWidth: "1440px", zIndex: "20", top: "0" }}
      width="full"
    >
      {/* Page title */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        paddingTop="medium"
        paddingBottom={{
          xs: "large",
          md: "xlarge",
        }}
      >
        <Heading variant="h3" component="h1">
          Reports
        </Heading>
      </Box>
      {/* End Page title */}

      {/* Forms */}
      <Stack>
        <RequestReportSection setUnableToDownload={setUnableToDownload} />
        <CustomerCompanyReportSection
          setUnableToDownload={setUnableToDownload}
        />
      </Stack>
      <Snackbar
        open={unableToDownload}
        tone="critical"
        align="left"
        showClose
        autoHideDuration={5000}
        onClose={() => setUnableToDownload(false)}
      >
        Unable to generate CSV
      </Snackbar>
      {/* End Forms */}
    </Box>
  );
};

export default Reports;
